<div >
  <div
    class="form-group form-group-lg margin-bottom-32"
    [ngClass]="{ hidden: false }"
  >
    <div class="custom-typeahead hubdrop" appClickOutside>
      <input
        #saerchInp
        class="form-control box-shadow"
        [ngClass]="{ 'has-error': false }"
        [(ngModel)]="locationItem"
        (ngModelChange)="valueChange($event)"
        (keydown)="updateSelection($event)" autocomplete="off"
        id="PostOfficeLocationAddress"
        name="PostOfficeLocationAddress"
        type="text"
        enableError="enableError"
        autocomplete="off"
        required
        appCheckEmpty
      />
      <label class="control-label" for="PostOfficeLocationAddress"
        >{{appCopy.panelHeader['postOfficeLookuplabel'+selectedLanguage]}}</label
      >
      <a
        class="control-btn"
        href="javascript:void(0)"
        (click)="clearInput()"
      >
        <i class="icon">cross</i>
      </a>

      <div class="control-btn">
        <i class="icon">search</i>
      </div>

      <div *ngIf="showLoader" class="loader-container-typeahead">
        <div class="loader loader--gray">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>

      <div *ngIf="postOfficeLocations.length > 0" class="items fadeIn">
        <div #container class="items-wrapper">
          <div
            (click)="container.scrollTo(0, 0)"
            class="item"
            *ngFor="let item of postOfficeLocations; let i = index"
            [ngClass]="{ active: isCurrent(i) }"
            (mouseenter)="setCurrent(i)"
            (click)="onSelection(item)"
          >
            <div
              class="flex-always flex--space-between"
              [ngClass]="{ 'address--street': true }"
            >
              <div>
                <h1 class="margin-bottom-4 title h4">{{ item.addressLine1 }}</h1>
                <p>{{ item.addressLine2 }}</p>
              </div>
              <span>{{ item.distance+'km' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- if not search result match -->
    </div>
  </div>
</div>
